import styled, {keyframes} from "styled-components";
import Row from "../Row/Row";
const Notification = styled(Row)`
    background: white;
    color: black;
    position: fixed;
    bottom: 5%;
    right: 2%;
    z-index: 2;
    border-radius: 10px;
    padding-inline: 3%;
`;

export const NotificationMessage = ({children}) => {

    return <Notification>
        {children}

    </Notification>
}